var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFontPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2,.cls-3{isolation:isolate;fill:#fff;}.cls-2{font-size:19.45px;font-family:Arial-BoldItalicMT, Arial;font-weight:700;font-style:italic;letter-spacing:-0.08em;}.cls-3{font-size:16.63px;font-family:ArialMT, Arial;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.34,
    y: 5.04,
    width: 13.32,
    height: 13.92
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1-2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(0.78 18.96)"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(13.75 16.99)"
  }, "+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontPlus);
export default __webpack_public_path__ + "static/media/font-plus.54d904dece7e6f83046a08b2310136d5.svg";
export { ForwardRef as ReactComponent };